import { Link } from '../components/base/Link';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
  const { i18n } = useTranslation();
  const english = i18n.language.startsWith('en');
  return (
    <main className="flex flex-col items-center justify-center min-h-screen text-center px-4">
      <p className="text-5xl font-semibold text-blue-600">404</p>
      <h1 className="text-2xl font-semibold mt-6">{english ? 'Page not found' : '页面不存在'}</h1>
      <p className="mt-4 text-gray-600">{english ? 'The page may have moved or the address may be incorrect.' : '页面可能已移动，或访问地址有误。'}</p>
      <Link to="/" className="mt-6 rounded-lg bg-blue-600 px-6 py-3 text-white">
        {english ? 'Return to homepage' : '返回首页'}
      </Link>
    </main>
  );
}
